import Basic from './basic.vue';
import MobBasic from './mob-basic.vue';

export const componentMap = {
	basic: Basic,
	'mob-basic': MobBasic
};
